import React from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import "./piatti.scss";

const Piatti = ({ overtitle, title, gallery }) => {
	return (
		<>
			<section
				className="module"
				id="specialities"
				style={{ backgroundColor: "#f6f6f6" }}>
				<div className="container">
					<div className="row">
						<div className="col-sm-2 col-sm-offset-5">
							<div className="alt-module-subtitle">
								<span className="holder-w"></span>
								<h5 className="font-serif">{overtitle}</h5>
								<span className="holder-w"></span>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-sm-8 col-sm-offset-2">
							<h2 className="module-title font-alt">{title}</h2>
						</div>
					</div>
					<div className="row multi-columns-row">
						<ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
							<Masonry
								gutter="0px"
								className="my-masonry-grid"
								columnClassName="my-masonry-grid_column">
								{gallery.map((piatto, index) => (
									<img
										key={index}
										src={piatto.image}
										alt={piatto.alt}
										style={{
											width: "100%",
											height: `${200 + Math.floor(Math.random() * 150)}px`,
											objectFit: "cover",
											display: "block",
										}}
									/>
								))}
							</Masonry>
						</ResponsiveMasonry>
					</div>
				</div>
			</section>
		</>
	);
};

export default Piatti;
